// Display helpers for a plan influencer row — formatCount backs the Plans
// screens, formatCompact the Script Approval screens.

export const formatCompact = (num) => {
  if (num === null || num === undefined) return "—";
  return new Intl.NumberFormat("en", { notation: "compact" }).format(num);
};

// Full, exact count with Indian digit grouping (4,93,000 rather than "493K")
// — what the Plans screens show for followers and averages, matching the ₹
// totals in the Plan Summary header. Averages can be fractional, so round to
// a whole count.
export const formatCount = (num) => {
  if (num === null || num === undefined || num === "" || Number.isNaN(Number(num))) return "—";
  return Math.round(Number(num)).toLocaleString("en-IN");
};

// Some records store a platform-prefixed key (e.g. "yt/@handle", "fb/handle")
// used internally for DB lookups — strip that prefix for display.
export const formatUsername = (username) => {
  if (!username) return null;
  // "tw/" (X) and "li/" (LinkedIn) are the same kind of internal prefix as "yt/"; a LinkedIn
  // company page is stored as "li/c/<slug>" and shown as "company/<slug>".
  const cleaned = username
    .replace(/^li\/c\//, "company/")
    .replace(/^(yt|fb|t|tw|li)\//, "")
    .replace(/^@/, "");
  return cleaned || null;
};

// Standard nano/micro/mid/macro/mega reach segmentation — the same breakdown
// influencer-marketing platforms (HypeAuditor, Later, etc.) use industry-wide,
// so "Micro" or "Macro" already means something to whoever's filtering rather
// than being a bucket invented just for this tool.
export const FOLLOWER_TIERS = [
  { value: "nano", label: "Nano (<10,000)", min: 0, max: 10_000 },
  { value: "micro", label: "Micro (10,000–1,00,000)", min: 10_000, max: 100_000 },
  { value: "mid", label: "Mid-tier (1,00,000–5,00,000)", min: 100_000, max: 500_000 },
  { value: "macro", label: "Macro (5,00,000–10,00,000)", min: 500_000, max: 1_000_000 },
  { value: "mega", label: "Mega (10,00,000+)", min: 1_000_000, max: Infinity },
];

// Shared by any tier-bucketed filter (follower/engagement) — null/undefined
// values (data never resolved yet) fall out of every bucket rather than being
// force-fit into "nano"/"low", matching how this table already treats missing
// numeric data everywhere else (sorts sink it to the bottom, never to zero).
export const bucketize = (value, tiers) => {
  if (value == null) return null;
  return tiers.find((t) => value >= t.min && value < t.max)?.value ?? null;
};
